<template>
    <div>
        <ModalGlobal id="logoutModal" v-if="modalLogout" @close-modal="modalLogout = false">
            <template #dialogHeadImg>
                <img class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
                    :src="$S3AssetUrl('suf/home/photo-pass-logo.png')" alt="logo photo" />
            </template>

            <template #dialogHeading>{{ $t('toolbar.logout_confirm') }}</template>

            <template #dialogDescription>{{ $t('toolbar.logout_info') }}</template>

            <a :disabled="loading" @click.prevent="logout"
                class="w-full flex justify-center rounded-full py-3 px-4 mb-4 bg-yellow-photo cursor-pointer font-semibold mx-auto">
                {{ $t('toolbar.logout_exit') }}
            </a>

            <button @click="modalLogout = false" :disabled="loading" type="button"
                class="w-full flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-white cursor-pointer font-semibold mx-auto">
                {{ $t('toolbar.logout_cancel') }}
            </button>
        </ModalGlobal>

        <ModalGlobal id="modalCurrencies" class="modalCurrencies" v-if="modalCurrencies"
            @close-modal="modalCurrencies = false">
            <template #dialogDescription>
                <p class="font-bold mb-8 text-center">
                    {{ $t("messages.change_language") }}
                </p>
                <div class="isoCurrencies flex flex-wrap -mb-1 mb-8">
                    <a @click="changeLanguage('es')"
                        class="uppercase flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-white cursor-pointer font-semibold"
                        v-if="$store.state.Language == 'en'">
                        <span class="isoCurrencyFlag lang"
                            :style="{ backgroundImage: 'url(' + $S3AssetUrl('suf/payments/flags/mxn.svg') + ')' }"></span>
                        ES
                    </a>
                    <a @click="changeLanguage('en')"
                        class="uppercase flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-white cursor-pointer font-semibold"
                        v-else>
                        <span class="isoCurrencyFlag lang"
                            :style="{ backgroundImage: 'url(' + $S3AssetUrl('suf/payments/flags/usd.svg') + ')' }"></span>
                        EN
                    </a>
                </div>
                <!-- routes: { href: "", flag: "", }, -->

                <template v-if="!removeCurrency">
                    <p class="font-bold mb-8 text-center">
                        {{ $t("messages.change_currency") }}
                    </p>
                    <div class="isoCurrencies flex flex-wrap -mb-1">
                        <button type="button"
                            class="flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-white cursor-pointer font-semibold"
                            :class="
                                item.iso == $store.state.Currency &&
                                'bg-yellow-photo'
                            " v-for="(item, idx) in currentCurrencies" :key="idx" @click.prevent="
                                item.iso != $store.state.Currency &&
                                    setNewCurrency(item.iso)
                            ">
                            <span class="isoCurrencyFlag" :style="{
                                    backgroundImage: 'url(' + $S3AssetUrl('suf/payments/flags/' + item.iso.toLowerCase() + '.svg') + ')'
                                }"></span>
                            
                            {{ item.iso }}
                        </button>
                    </div>
                </template>

            </template>
        </ModalGlobal>

        <LoginModal />

        <!-- Todo: se mostrara cuando un usuario este logeado -->
        <!-- <SessionExpiredModal /> -->

        <header class="z-40 headerNav">
            <nav class="bg-real-white nav-border-button">
                <div class="container items-center py-2 p-2">
                    <router-link :to="{ name: 'home' }" class="navbar-logo flex items-center">
                        <img class="h-auto min-w-36 w-1/2"
                            :src="$S3AssetUrl('suf/logos/white-logos/gpo-xcaret-black.png')"
                            alt="Grupo Xcaret" title="Grupo Xcaret" />
                    </router-link>

                    <ul class="flex flex-auto justify-end items-center font-three text-dark">
                        <li class="px-2 cursor-pointer nav-link">
                            <router-link :to="{ name: 'faqs' }">
                                <span class="material-icons">
                                    help_outline
                                </span>

                                <span class="ml-1 hidden-less-ipad">{{ $t('toolbar.faqs') }}</span>
                            </router-link>
                        </li>

                        <li class="px-2 cursor-pointer hidden nav-link">
                            <!-- <font-awesome-icon :icon="['far', 'circle-question']" /> -->
                            <span class="material-icons"> help_outline </span>

                            <span class="ml-1 hidden-less-ipad">{{ $t('toolbar.help') }}</span>
                        </li>

                        <li class="px-2 cursor-pointer relative nav-link">
                            <!-- Usuario autentificado -->
                            <div v-if="$store.getters.authStateLogged" @click="modalLogout = true">
                                <span class="material-icons"> logout </span>

                                <span class="ml-1 pointer-events-none hidden-less-ipad">
                                    {{ $t('toolbar.logout') }}
                                </span>
                            </div>
                            <!-- Usuario invitado -->
                            <div v-else-if="$store.getters.authStateGuest && $route.name != 'home'"
                                @click="modalLogout = true">
                                <span class="material-icons"> logout </span>

                                <span class="ml-1 pointer-events-none hidden-less-ipad">
                                    {{ $t('toolbar.logout') }} ({{ $t('Forms.guest') }})
                                </span>
                            </div>
                            <!-- Usuario no autentificado invitacion a legearse -->
                            <div @click.prevent="$store.dispatch('setModalLogin', true), setModalAuth(1)" v-else>
                                <span class="material-icons"> login </span>
                                <span class="ml-1 pointer-events-none hidden-less-ipad">{{ $t('Forms.login') }}</span>
                            </div>

                            <InvitationLogin v-if="$route.name == 'home'" />
                        </li>

                        <li class="flex items-center mx-2 cursor-pointer hidden-less-ipad nav-link">
                            <span class="ml-1" v-if="!removeCurrency">
                                <span @click.prevent="modalCurrencies = true">
                                    {{ $store.state.Currency }}
                                    <span class="material-icons">
                                        arrow_drop_down
                                    </span>
                                </span>
                            </span>
                            <span class="ml-1" v-else>
                                {{ $store.state.Currency }}
                            </span>
                        </li>

                        <li class="flex items-center mx-2 cursor-pointer hidden-less-ipad languages nav-link"
                            @click="modalCurrencies = true">
                            <a>
                                <img class="relative h-5 img"
                                    :src="$S3AssetUrl('suf/' + $store.state.Language + '.png')"
                                    alt="language" />
                                <span class="relative ml-1 lang-text uppercase">
                                    {{ $store.state.Language }}
                                    <span class="material-icons">
                                        arrow_drop_down
                                    </span>
                                </span>
                            </a>
                        </li>

                        <li class="px-2 cursor-pointer hidden show-less-ipad" @click="modalCurrencies = true">
                            <span class="material-icons lang"> language </span>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import methodUser from "./mixins/methodUser";
import Users from "./mixins/Users";

import Currencies from "./logic/payment/Currency";
import PaymentBanks from "./logic/payment/PaymentBanks";

import LoginModal from "../components/Modals/LoginModal.vue";
import SessionExpiredModal from "../components/Modals/SessionExpiredModal.vue";
import InvitationLogin from "@components/partials/InvitationLogin.vue";

export default {
    props: ["route", "lang"],
    mixins: [methodUser, Users],
    components: { LoginModal, SessionExpiredModal, InvitationLogin },
    data: () => ({
        modalLogout: false,
        modalCurrencies: false,
        routes: {
            href: "",
            flag: "",
        },
        currentCurrencies: [],
    }),
    computed: {
        removeCurrency() {
            let currentRoute = this.$route?.name;
            let excludeRoutes = ["payment"];
            if (currentRoute == undefined || currentRoute == null) return false;

            return currentRoute.includes(excludeRoutes);
        }
    },
    watch: {},
    methods: {
        // Usar acciones de 'auth' module
        ...mapActions('auth', ['setModalAuth']),
        changeLanguage(lang) {
            this.$store.dispatch("setLanguage", lang);
            
            const langPath = lang === 'en' ? '' :  `${lang}.`;

            const route = this.$router.resolve({
                name: `${langPath}${this.$route.name}`,
                query: this.$route.query,
            });

            location.href =  window.location.origin + route.href;
        },
        redirectTo() {
            let routes = this.$route.fullPath;
            const url = this.lang == "en" ? routes.replace("es/", "/") : `es${routes}`;
            const flag = this.lang == "es" ? "mxn" : "usd";

            return this.routes = { href: url, flag: flag, lang: this.lang };
        },
        //  Funcion para la obtencion de los Paises
        async getCurrenciesData() {
            try {
                let response = await Currencies.get();
                this.$store.dispatch("setCurrencies", response.currencies);
                this.currentCurrencies = this.GetAvailableCurrencies();

                const iso = this.$store.state.Language == "es" ? "MXN" : "USD";
                localStorage.setItem("currency", iso);
                
            } catch (error) {
                
            }
        },
        //  Funcion para la obtencion de las Ciudades confome su Pais
        async getPaymentBanksData() {
            try {
                const response = await PaymentBanks.get(
                    this.$store.state.payment.Amount
                );
                if (response.hasOwnProperty("banks")) {
                    this.$store.dispatch("SetBanks", response.banks);
                }

                if (response.hasOwnProperty("safetyPayBanks")) {
                    this.$store.dispatch(
                        "SetSafetyPayBanks",
                        response.safetyPayBanks
                    );
                }

                
                
            } catch (error) {
                
            }
        },
        /**
         * Checks if a currency option can be displayed by the currency picker.
         * Invalid ISO-like values returned by upstream services are discarded
         * dynamically instead of maintaining a local denylist.
         *
         * @param {object} currency Currency option returned by the API.
         * @returns {boolean} True when the currency can be rendered.
         */
        IsValidCurrencyOption(currency) {
            const iso = String(currency?.iso || "").trim();

            if (!/^[A-Z]{3}$/.test(iso)) {
                return false;
            }

            if (typeof Intl !== "undefined" && typeof Intl.DisplayNames === "function") {
                const displayName = new Intl.DisplayNames([this.$store.state.Language || "es"], {
                    type: "currency",
                }).of(iso);

                return Boolean(displayName && displayName !== iso);
            }

            return true;
        },
        /**
         * Returns the available currencies after applying the current route rules.
         *
         * @returns {Array} Valid currency options for the active route.
         */
        GetAvailableCurrencies() {
            const currencies = (this.$store.state.Currencies || []).filter(this.IsValidCurrencyOption);

            if (this.$route?.name === "triatlon") {
                return currencies.filter(currency =>
                    currency.iso === "MXN" || currency.iso === "USD"
                );
            }

            return currencies;
        },
        /**
         * Filter currencies available for the current route.
         */
        async GetTriatlonCurrencies(){
            this.currentCurrencies = this.GetAvailableCurrencies();
        },
        /**
         * Set New Currency
         * @param {string} iso - Currency ISO code
         */
        async setNewCurrency(iso) {
            localStorage.setItem("currency", iso);

            try {
                await this.$store.dispatch("setCurrency", iso);
            } finally {
                this.modalCurrencies = false;
            }
        }
    },
    updated() {
        if (!this.$store.state.Parks.length) this.$store.dispatch("getParks");

        this.GetTriatlonCurrencies();
    },
    created() {
        if (!this.$store.state.Parks.length) this.$store.dispatch("getParks");
        // Generamos las url confoem a su lenguaje
        this.redirectTo();

        if (!this.$store.state.Currencies.length) this.getCurrenciesData();

        if (this.$store.state.Currency == "") {
            const iso = this.$store.state.Language == "es" ? "MXN" : "USD";
            localStorage.setItem("currency", iso);
            if (!this.$store.state.Banks.length) this.setNewCurrency(iso);
        }

        this.currentCurrencies = this.GetAvailableCurrencies();
        
        this.GetTriatlonCurrencies();
    },
    mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../css/variables.scss";

nav {

    .container {
        display: flex;

        justify-content: center;

        margin-left: auto;

        margin-right: auto;
    }

    .navbar-coupon {
        border: 1px solid #101010;

        background-color: $yellow-photo;

        padding: 0.25rem 1.6rem;

        border-radius: 20px;
    }
}

.navbar-logo {
    img {
        align-items: center;
    }

    span {
        padding-left: 0.5rem;

        font-size: 1.25rem;
    }
}
</style>
